import { useEffect } from "react";
import { Route, Switch, useLocation, useParams } from "wouter";
import { AppRoleView } from "./app-role.view";

function RedirectToGroupRoot() {
  const params = useParams<{ groupUuid: string }>();
  const [, navigate] = useLocation();

  useEffect(() => {
    if (!params.groupUuid) return;
    navigate(`~/ram/group/${params.groupUuid}`, { replace: true });
  }, [navigate, params.groupUuid]);

  return null;
}

export function AppRoleRoutes() {
  return (
    <Switch>
      <Route path={"/"} component={AppRoleView} />
      <Route component={RedirectToGroupRoot} />
    </Switch>
  );
}
